import React from 'react';
import './Sidebar.css';   // reuse existing sidebar styling

const LandingSidebar = () => {
    return (
        <div className="sidebar-right landing-sidebar">
            <div className="video-wrapper">
                <video
                    className="wow-video"
                    src="/videos/GrowYourFood.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                />
            </div>
        </div>
    );
};

export default LandingSidebar;
